import { formatAcChip } from './featureBoardRows';
import { clubFields, clubTracts, isHuntField } from './clubBoundaryRole';

function byName(a, b) {
  return String(a?.name || '').localeCompare(String(b?.name || ''), undefined, {
    sensitivity: 'base',
  });
}

export function clubAreaBoardGroups(boundaries) {
  return {
    tracts: clubTracts(boundaries).slice().sort(byName),
    fields: clubFields(boundaries).slice().sort(byName),
  };
}

export function clubAreaRoleLabel(area) {
  return isHuntField(area) ? 'FIELD' : 'TRACT';
}

export function clubAreaAcresLabel(area) {
  return formatAcChip(area?.acreage);
}

/** [west, south, east, north] from a tract/field GeoJSON. */
export function bboxFromAreaGeojson(geojson) {
  if (!geojson || typeof geojson !== 'object') return null;
  let minLng = Infinity;
  let minLat = Infinity;
  let maxLng = -Infinity;
  let maxLat = -Infinity;
  const extend = (lng, lat) => {
    if (typeof lng !== 'number' || typeof lat !== 'number') return;
    if (lng < minLng) minLng = lng;
    if (lat < minLat) minLat = lat;
    if (lng > maxLng) maxLng = lng;
    if (lat > maxLat) maxLat = lat;
  };
  if (geojson.type === 'Polygon' && geojson.coordinates?.[0]) {
    geojson.coordinates[0].forEach((c) => extend(c[0], c[1]));
  } else if (geojson.type === 'MultiPolygon' && Array.isArray(geojson.coordinates)) {
    geojson.coordinates.forEach((poly) => {
      if (Array.isArray(poly?.[0])) poly[0].forEach((c) => extend(c[0], c[1]));
    });
  }
  if (minLng === Infinity) return null;
  return [minLng, minLat, maxLng, maxLat];
}

export function clubLandHasEditableShape(feature) {
  if (!feature) return false;
  if (feature.featureType === 'hunt_boundary') return true;
  const geom = feature.geojson?.type || feature.type;
  return geom === 'Polygon' || geom === 'MultiPolygon' || geom === 'polygon';
}

export function clubBoardBoundaryAsEditFeature(boundary) {
  if (boundary == null || boundary.id == null) return null;
  const numericId = Number(boundary.id);
  if (!Number.isFinite(numericId)) return null;
  return {
    ...boundary,
    id: `boundary-${numericId}`,
    featureType: 'hunt_boundary',
    type: 'polygon',
    is_boundary: boundary.is_boundary !== false,
  };
}
